(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gb-whatsapp"] && !Shopify.designMode) return;
  try {
    // Yield to buying controls when the floating shortcut would cover them.
  const shortcut = document.querySelector('.gb-whatsapp');
  if (shortcut) {
    let pending = false;
    const checkClearance = () => {
      pending = false;
      const box = shortcut.getBoundingClientRect();
      const controls = document.querySelectorAll('main button, main a.button, .gb-hero a, .gb-why__cta, .gb-buying-help a');
      const obstructing = [...controls].some((control) => {
        const rect = control.getBoundingClientRect();
        return rect.width && rect.height && rect.left < box.right && rect.right > box.left &&
          rect.top < box.bottom && rect.bottom > box.top;
      });
      shortcut.classList.toggle('gb-whatsapp--obstructing', obstructing);
    };
    const scheduleClearance = () => {
      if (!pending) { pending = true; requestAnimationFrame(checkClearance); }
    };
    addEventListener('scroll', scheduleClearance, { passive: true });
    addEventListener('resize', scheduleClearance);
    addEventListener('load', scheduleClearance, { once: true });
    const main = document.querySelector('main');
    if (main) new ResizeObserver(scheduleClearance).observe(main);
    checkClearance();
  }
  } catch(e) { console.error(e); }
})();

})();
